import { useEffect } from 'react';

/**
 * Custom hook to run a function on component unmount
 */
/* eslint-disable  react-hooks/exhaustive-deps */
const useUnmount = (func) => useEffect(() => func, []);
/* eslint-enable  react-hooks/exhaustive-deps */

export default useUnmount;
